export default __webpack_public_path__ + "static/media/cert-general-staff-a-cpttm.3393f7cd.jpg";